import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Cookies from 'js-cookie';
import brandingJson from '../assets/Branding/vuetify.branding.json'

Vue.use(Vuetify);

let expCodeCookieVal = Cookies.get('exp');
var branding = brandingJson[0].theme;
if (expCodeCookieVal != null) {
    var lowercaseCode = expCodeCookieVal.toLowerCase();
    var tindex = brandingJson.findIndex(x => x.key === lowercaseCode);
    if (tindex >= 0)
        branding = brandingJson[tindex].theme;
}

export default new Vuetify({
    theme: branding
});
